"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InfoIcon = exports.InfoIcon = function InfoIcon(_ref) {
  var _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? "#e17b82" : _ref$fillColor;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: fillColor,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "1",
    transform: "translate(-476 -671) translate(438 281) translate(38 388) translate(0 2)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.216 0A9.21 9.21 0 000 9.216a9.21 9.21 0 009.216 9.216 9.21 9.21 0 009.216-9.216A9.21 9.21 0 009.216 0zm0 16.992A7.772 7.772 0 011.44 9.216 7.772 7.772 0 019.216 1.44a7.772 7.772 0 017.776 7.776 7.772 7.772 0 01-7.776 7.776z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.216 4.64a.72.72 0 00-.72.72v4.636a.72.72 0 101.44 0V5.36a.72.72 0 00-.72-.72z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "9.216",
    cy: "12.57",
    r: "1"
  })));
};